export default "__VITE_ASSET__d599bf71__"